export default {
  getCostCentre: (state) => state.costCentre,
};
